import axiosServices from 'utils/axios';
import { GenericTableDataFileDto, GenericResponseFileDto } from './dto';
import { InsideFifaBackOfficeEndpoints } from '../consts';

export const deleteApiFile = async (data: GenericTableDataFileDto): Promise<GenericResponseFileDto> => {
    const res = await axiosServices.delete<GenericResponseFileDto>(
        `${InsideFifaBackOfficeEndpoints.GenericTables.Files}/${data.fileId}`,
    );
    return res.data;
};
